import React, { forwardRef, useMemo, useCallback, useRef } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';
import { split } from "utils/lodashUtils";

const TenableWebappMappingForm = forwardRef(function TenableWebappMappingForm(props, ref) {
  const configNameMap = useRef({});

  const fetchProjects = useCallback((params) => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(
      props.toolName, { login_id: props.loginConfigId, ...params });
    promise.then(res => res.projects.forEach(p => { 
      configNameMap.current[p.id] = p.name;
    }));
    return { promise, cancel };
  }, [props.loginConfigId, props.toolName]);

  const parseSelectOptions = useCallback((projects) => {
    return projects.map(project => ({
      label: `${project.name} (${project.id})`,
      value: project.id
    }));
  }, []);

  const getExtraFieldsData = useCallback((config) => {
    const configName = config.configId.map(value => {
      return configNameMap.current[value] + ' (' + value + ')';
    });

    return ({
      configId: config.configId.join(','),
      configName: configName.join(','),
    });
  }, []);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { configId } = config;
    return {
      configId: split(configId, ",")
    }
}, []);

  const extraFields = useMemo(() => ([
    {
      name: 'configId',
      colSpan: '12',
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      label: 'Scan Name (ID)',
      help: 'The ID is visible in the URL when clicking on the "edit scan" option on Tenable platform.',
      rules: [{ required: true, message: `Scan Name is required` }],
      props: {
        api: fetchProjects,
        mode: "multiple",
        allowClear: true,
        autoFocus: true,
        parseSelectOptions: parseSelectOptions
      }
    }
  ]), [fetchProjects]);

  return (
    <GenericMappingForm
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default TenableWebappMappingForm;
